import { Box } from '@mui/material';

interface NoDataProps {
  content?: string | null;
}

const NoData = ({ content }: NoDataProps) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" py={10}>
      {content ?? 'No data found.'}
    </Box>
  );
};

export default NoData;
